// ======================================================================
// File Name       : AuthAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import moment from 'moment';
import { ADMIN_SCRIPT_S3_PATH, ADMIN_TYPES, DEFAULT_DATE_FORMAT_SEARCH, EXTERNAL_REQUEST_PASSCD, LO_SUPER_USER, MESSAGE_TYPE, SELECT_TARGET_DATA, SUPER_USER, X_SSAPI_VERSION, USAGE_SETTING, NEW_PASSWORD_SETTING_URL } from '../constants';
import { IMPORT_S3_SIGNED_URL, LOGOUT, RECEIVE_AUTHED_USER } from '../constants/ActionTypes';
import { BILLING_SYSTEM_REGISTER_FLAG_STATUS, ENTERPRISE_LAYER_L1 } from '../constants/EnterpriseConstants';
import { E_SYSTEM_ERROR, MSG_LOGIN_INCORRECT, MSG_USING_WRONG_CERTIFICATE } from '../constants/MessageTemplate';
import { S3_SCRIPT_CLASS_NAME } from '../constants/S3Constants';
import { HIDE_MESSAGE, SHOW_MESSAGE } from '../constants/actionTypes/message';
import store from '../store';
import { commonCallApi, logoutApi } from '../utils/ApiUtils';
import {
  initLeftNavigator, initRoute,
  initTopNavigator, initUserFunctionByAuthority, isOEMUser
} from '../utils/AuthedUtils';
import { getStructure } from './EnterpriseAction';
import { getServiceInfoAfterLogin } from './ServiceAction';
import { getSuperUserInfoAfterLogin } from './SuperUserAction';
import { getUserInfoAfterLogin, getManagementUserInfo, postUserGetManagementServiceList } from './UserAction';
import { postCheckAvailability } from './httpRequests/enterprise';
import { postServiceGroupGetSuperUserRelation } from './httpRequests/serviceGroup';
import { postUserGroupRelationGetList } from './httpRequests/user';
import { IS_SHOW_LIVE_TAB, LIVE_MANAGEMENT_AUTHORITY_TYPE } from '../constants/AuthorityConstant';
import { TOKEN } from '../constants/LocalStorageConstants';
import * as SessionStorageUtils from '../utils/SessionStorageUtils';
import { isSuperUser } from '../utils';
import { receivedServiceGroupGetSuperUserRelation } from './ServiceGroupAction';
import { createLoginAllServiceRelation } from '../utils/SuperUserUtils';
import * as ServiceRecordAction from './serviceRecord/ServiceRecordAction';
import { SUPERUSER_LOGIN_TYPE } from '../constants/CommonConstants';
import { isIntegrationUserLoggedIn, checkShowLogo } from '../utils/PageUtils';
import { getServiceList } from './httpRequests/service';

export function login(loginInfo, certificateLoginApiGatewayUrl) {
  return (dispatch) => {
    commonCallApi({
      path: 'auth/Login',
      data: loginInfo,
      certificateLoginApiGatewayUrl, // #7303
    }).then((camelizeJson) => {
      // STEP9.0.0 START
      const { userInfo, token } = camelizeJson;
      if (userInfo) {
        token && localStorage.setItem(TOKEN, token); // Step 10.0.0
      // STEP9.0.0 END
        if (!(ADMIN_TYPES.indexOf(userInfo.displayUserType) > -1)) {
          return dispatch({
            type: SHOW_MESSAGE,
            message: MSG_LOGIN_INCORRECT,
            messageType: MESSAGE_TYPE.error,
          });
        }
      } else {
        return dispatch({
          type: SHOW_MESSAGE,
          message: E_SYSTEM_ERROR,
          messageType: MESSAGE_TYPE.error,
        });
      }

      let serviceCd = null;

      userInfo.loginId = loginInfo.loginId;
      userInfo.serviceCd = serviceCd;
      //Step9.0.0 START
      SessionStorageUtils.save('loginId', loginInfo.loginId);
      //Step9.0.0 END

      if (loginInfo.serviceCd) {
        serviceCd = loginInfo.serviceCd;
        camelizeJson.serviceCd = serviceCd;
        const param = {
          authCd: camelizeJson.authCd,
          institutionId: camelizeJson.institutionId,
          selectTargetData: SELECT_TARGET_DATA.DATA,
          searchInfo: {
            serviceCdList: [serviceCd],
          },
          // #7385 START
          smst: true,
          token: camelizeJson.token,
          // #7385 END
        };
        // Step10.0.0 START
        const searchUserInfo = {
          userSecernId: userInfo.userSecernId,
          institutionId: camelizeJson.institutionId,
          authCd: camelizeJson.authCd,
          token: camelizeJson.token,
        };
        const searchUserGroupInfo = {
          searchInfo: {
            userList: [userInfo.userSecernId],
          },
          institutionId: camelizeJson.institutionId,
          authCd: camelizeJson.authCd,
          token: camelizeJson.token,
          selectTargetData: SELECT_TARGET_DATA.DATA,
        };
        return dispatch(getUserInfoAfterLogin(searchUserInfo)).then((userJson) => {
          camelizeJson.userInfo.mailAddress = userJson.userList[0].mailAddress;
          return postUserGroupRelationGetList(searchUserGroupInfo).then((res) => {
            camelizeJson.isBelongUserGroup = res.recordNum > 0;
            return getServiceInfo(dispatch, param, camelizeJson);
          });
        });
        // Step10.0.0 END
      }
      // sprint_20230418 #12 START
      // call superuser/GetList
      if (loginInfo.enterpriseCd) {
        const { enterpriseId } = camelizeJson;
        const { userSecernId } = userInfo;
        const param = {
          enterpriseId,
          userSecernId,
          authCd: camelizeJson.authCd,
          token: camelizeJson.token,
        };
        // Step10.2.0 START
        const paramGetAll = {
          selectTargetData: SELECT_TARGET_DATA.DATA,
          enterpriseId,
          authCd: camelizeJson.authCd,
          token: camelizeJson.token,
        };
        // Step10.2.0 END
        // Step 13.0.0 TAS-22874 START
        getServiceList(paramGetAll).then((resServiceData) => {
          camelizeJson.serviceNum = resServiceData.serviceList.length;
        });
        // Step 13.0.0 TAS-22874 END
        return dispatch(getSuperUserInfoAfterLogin(param)).then(async (superUserJson) => {
          const { superuserList } = superUserJson;
          if (superuserList[0]) {
            camelizeJson.rootFlag = superuserList[0].rootFlag;
            camelizeJson.readOnlyFlag = superuserList[0].readOnlyFlag;
            camelizeJson.userInfo.mailAddress = superuserList[0].mailAddress; // Step10.0.0
            camelizeJson.loginSuperuserEnterpriseRoleSecernId = superuserList[0].superuserEnterpriseRoleSecernId; // Step 10.2.0
          }
          // sprint_20230418_#17 START
          const enterpriseParam = {
            enterpriseId: camelizeJson.enterpriseId,
            authCd: camelizeJson.authCd,
            smst: true,
            token: camelizeJson.token,
            selectTargetData: SELECT_TARGET_DATA.DATA,
            targetEnterpriseCd: loginInfo.enterpriseCd,
          };
          // Step10.0.0 START
          const searchServiceGroupInfo = {
            searchInfo: {
              serviceGroupSecernId: null,
              superuserSecernId: userInfo.userSecernId,
            },
            enterpriseId: camelizeJson.enterpriseId,
            token: camelizeJson.token,
            authCd: camelizeJson.authCd,
          };
          // Step 10.2.0 START
          const superuserServiceRoleSettingListParam = {
            enterpriseId: camelizeJson.enterpriseId,
            token: camelizeJson.token,
            authCd: camelizeJson.authCd,
            superuserSecernId: userInfo.userSecernId,
          };
          // Step 11.0.0 START
          const paramServiceLogin = {
            enterpriseId: camelizeJson.enterpriseId,
            token: camelizeJson.token,
            authCd: camelizeJson.authCd,
            selectTargetData: SELECT_TARGET_DATA.DATA,
            searchInfo: {
              serviceCdList: [camelizeJson.serviceCd],
            },
          };
          // Step 11.0.0 END

          let res = await postServiceGroupGetSuperUserRelation(searchServiceGroupInfo);
          camelizeJson.isBelongServiceGroup = res.recordNum > 0;
          dispatch(receivedServiceGroupGetSuperUserRelation(null, res.recordNum, res.serviceGroupRelationList));
          await getEnterpriseInfo(dispatch, enterpriseParam, camelizeJson);
          res = await dispatch(getSuperuserServiceRoleSettingList(superuserServiceRoleSettingListParam));
          camelizeJson.loginSuperuserServiceRoleList = createLoginAllServiceRelation(res.roleList);
          dispatch(initAppDataFromAuthedInfo(camelizeJson));
          // Step 12.0.0 TAS-20042 START
          if (
            camelizeJson?.enterpriseManagementFunctionAuthorityInfo?.superuserManagementAuthority > 0 &&
            camelizeJson?.institutionId
          ) {
            await getAllGroupOwnerFlag(camelizeJson);
          }
          // Step 12.0.0 TAS-20042 END
          await getServiceInfo(dispatch, paramServiceLogin, camelizeJson); // Step 11.0.0
          // Step 10.2.0 END
          // Step10.0.0 END
          // sprint_20230418_#17 END
        });
        // sprint_20230418 #12 END
      }

      return dispatch(initAppDataFromAuthedInfo(camelizeJson));
    })
    .catch((error) => {
      if (certificateLoginApiGatewayUrl && error && !error.statusCd) {
        dispatch({ type: HIDE_MESSAGE });
        return dispatch({
          type: SHOW_MESSAGE,
          message: MSG_USING_WRONG_CERTIFICATE,
          messageType: MESSAGE_TYPE.error,
        });
      }
    });
  };
}

export function checkLogin() {
  // STEP9.0.0 START
  const token = localStorage.getItem(TOKEN);
  return dispatch =>
    commonCallApi({
      path: 'auth/LoginCheck',
      data: { token, },
    })
      .then((camelizeJson) => {
        const { userInfo } = camelizeJson;
        camelizeJson.token = token;
        // STEP9.0.0 END
        if (userInfo) {
          if (!(ADMIN_TYPES.indexOf(userInfo.displayUserType) > -1)) {
            return dispatch({
              type: LOGOUT,
            });
          }
        }
        //Step9.0.0 START
        SessionStorageUtils.save('loginId', userInfo.loginId);
        //Step9.0.0 END
        // Step 12.2.0 TAS-15267 START
        if (camelizeJson?.userInfo?.passwordChangeFlag) {
          window.location.href = NEW_PASSWORD_SETTING_URL;
        }
        // Step 12.2.0 TAS-15267 END

        if (camelizeJson.serviceCd && !isSuperUser(camelizeJson.userInfo.displayUserType)) { // Step 10.0.0
          const param = {
            institutionId: camelizeJson.institutionId,
            selectTargetData: SELECT_TARGET_DATA.DATA,
            searchInfo: {
              serviceCdList: [camelizeJson.serviceCd],
            },
            // #7385 START
            smst: true,
            token,
          // #7385 END
          };
          window.saveToken(token);
          window.sendToken(token);

          // Step10.0.0 START
          const searchUserInfo = {
            userSecernId: userInfo.userSecernId,
            institutionId: camelizeJson.institutionId,
            authCd: camelizeJson.authCd,
            token: camelizeJson.token,
          };
          const searchUserGroupInfo = {
            searchInfo: {
              userList: [userInfo.userSecernId],
            },
            institutionId: camelizeJson.institutionId,
            authCd: camelizeJson.authCd,
            token: camelizeJson.token,
            selectTargetData: SELECT_TARGET_DATA.DATA,
          };
          return dispatch(getUserInfoAfterLogin(searchUserInfo)).then(
            (userJson) => {
              camelizeJson.userInfo.mailAddress =
                userJson.userList[0].mailAddress;
              return postUserGroupRelationGetList(searchUserGroupInfo).then((res) => {
                camelizeJson.isBelongUserGroup = res.recordNum > 0;
                return getServiceInfo(dispatch, param, camelizeJson);
              });
            }
          );
          // Step10.0.0 END
        }
        // sprint_20230418 #12 START
        // STEP 12.0.0 START
        if (
          camelizeJson.userInfo.integrationUserSecernId
          && camelizeJson.userInfo.superuserType === SUPERUSER_LOGIN_TYPE.INTEGRATION_SUPERUSER
          && isIntegrationUserLoggedIn
        ) {
          const param = {
            auth_cd: camelizeJson.authCd,
            superuser_secern_id: camelizeJson.userInfo.integrationUserSecernId,
            token: camelizeJson.token,
          }
          dispatch(getManagementUserInfo(param));
        }
        // STEP 12.0.0 END
        if (camelizeJson.enterpriseCd) {
          const { enterpriseId, enterpriseManagementFunctionAuthorityInfo: { hiddenStatusSetting } } = camelizeJson;
          const { userSecernId } = userInfo;
          camelizeJson.hiddenStatusSetting = hiddenStatusSetting; // step 12.0.0
          const param = {
            enterpriseId,
            userSecernId,
            token,
          };
          // Step10.2.0 START
          const paramGetAll = {
            selectTargetData: SELECT_TARGET_DATA.DATA,
            enterpriseId,
            authCd: camelizeJson.authCd,
            token: camelizeJson.token,
          };
          // Step 13.0.0 TAS-22874 START
          getServiceList(paramGetAll).then((resServiceData) => {
            camelizeJson.serviceNum = resServiceData.serviceList.length;
          });
          // Step 13.0.0 TAS-22874 END
          // Step10.2.0 END
          return dispatch(getSuperUserInfoAfterLogin(param)).then(async (superUserJson) => {
            const { superuserList } = superUserJson;
            const searchServiceGroupInfo = {
              searchInfo: {
                serviceGroupSecernId: null,
                superuserSecernId: userInfo.userSecernId,
              },
              enterpriseId: camelizeJson.enterpriseId,
              token: camelizeJson.token,
              authCd: camelizeJson.authCd,
            };

            // Step10.2.0 START
            const superuserServiceRoleSettingListParam = {
              enterpriseId: camelizeJson.enterpriseId,
              token: camelizeJson.token,
              authCd: camelizeJson.authCd,
              superuserSecernId: userInfo.userSecernId,
            };
            // Step10.2.0 END

            // sprint_20230418_#17 START
            const enterpriseParam = {
              enterpriseId: camelizeJson.enterpriseId,
              selectTargetData: SELECT_TARGET_DATA.DATA,
              targetEnterpriseCd: camelizeJson.enterpriseCd,
              token,
            };
            // sprint_20230418_#17 END

            // Step 10.2.0 START
            if (superuserList[0]) {
              // Step10.0.0 START
              const { readOnlyFlag, mailAddress, rootFlag, superuserEnterpriseRoleSecernId } = superuserList[0];
              camelizeJson.readOnlyFlag = readOnlyFlag;
              camelizeJson.userInfo.mailAddress = mailAddress;
              camelizeJson.rootFlag = rootFlag;
              camelizeJson.loginSuperuserEnterpriseRoleSecernId = superuserEnterpriseRoleSecernId; // Step 10.2.0
              // Step 10.2.0 END
            }
            if (camelizeJson.serviceCd) {
              const paramServiceList = {
                enterpriseId: camelizeJson.enterpriseId,
                token: camelizeJson.token,
                authCd: camelizeJson.authCd,
                selectTargetData: SELECT_TARGET_DATA.DATA,
                searchInfo: {
                  serviceCdList: [camelizeJson.serviceCd],
                },
              };
              const enterpriseParamAfterLoginService = {
                enterpriseId: camelizeJson.enterpriseId,
                selectTargetData: SELECT_TARGET_DATA.DATA,
                targetEnterpriseCd: camelizeJson.enterpriseCd,
                token: camelizeJson.token,
              };
              // Step10.2.0 START
              let res = await postServiceGroupGetSuperUserRelation(searchServiceGroupInfo);
              dispatch(receivedServiceGroupGetSuperUserRelation(null, res.recordNum, res.serviceGroupRelationList));
              camelizeJson.isBelongServiceGroup = res.recordNum > 0;
              await getEnterpriseInfo(dispatch, enterpriseParam, camelizeJson); // Step 11.0.0
              res = await dispatch(getSuperuserServiceRoleSettingList(superuserServiceRoleSettingListParam));
              camelizeJson.loginSuperuserServiceRoleList = createLoginAllServiceRelation(res.roleList);
              await getEnterpriseInfo(dispatch, enterpriseParamAfterLoginService, camelizeJson);
              // Step 12.0.0 TAS-20042 START
              if (
                camelizeJson?.enterpriseManagementFunctionAuthorityInfo?.superuserManagementAuthority > 0 &&
                camelizeJson?.institutionId
              ) {
                await getAllGroupOwnerFlag(camelizeJson);
              }
              // Step 12.0.0 TAS-20042 END
              return getServiceInfo(dispatch, paramServiceList, camelizeJson);
              // Step10.2.0 END
            }
            // Step10.0.0 END
            // Step10.0.0 START
            // Step10.2.0 START
            let res = await postServiceGroupGetSuperUserRelation(searchServiceGroupInfo);
            dispatch(receivedServiceGroupGetSuperUserRelation(null, res.recordNum, res.serviceGroupRelationList));
            camelizeJson.isBelongServiceGroup = res.recordNum > 0;
            await getEnterpriseInfo(dispatch, enterpriseParam, camelizeJson);
            res = await dispatch(getSuperuserServiceRoleSettingList(superuserServiceRoleSettingListParam));
            camelizeJson.loginSuperuserServiceRoleList = createLoginAllServiceRelation(res.roleList);
            dispatch(initAppDataFromAuthedInfo(camelizeJson));
            // Step10.2.0 END
            // Step10.0.0 END
          });
        }
        // sprint_20230418 #12 END

        dispatch(initAppDataFromAuthedInfo(camelizeJson));
      })
      .catch((errorMsg) => {
        dispatch({
          type: HIDE_MESSAGE,
        });
        dispatch({
          type: LOGOUT,
        });
      });
}

/**
 * Update new auth when login service
 * @param {*} authedUser
 */
export function updateAuthUserService(serviceCd, newAuthedUser) {
  // STEP7.0 #3 START
  return (dispatch, getState) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        serviceCdList: [serviceCd],
      },
    };
    commonCallApi({
      path: 'service/GetList',
      data: param,
      enterpriseId: 1,
    }).then((camelizeJson) => {
        const { authed } = getState();
        const { authedUser } = authed;
        const { serviceList } = camelizeJson;
        const { usageSettingInfo } = serviceList[0];
        authedUser.userInfo.representationUserSecernId = newAuthedUser.representationUserSecernId;
        // Asign new auth by login service
        const newAuthed = { ...authedUser, ...newAuthedUser, ...{ serviceCd }, ...usageSettingInfo };
        dispatch(initAppDataFromAuthedInfo(newAuthed));
      });
  };
  // STEP7.0 #3 END
}

/**
 * Logout
 * @param {*} param
 */
export function logout() {
  return dispatch =>
    logoutApi({
      path: 'auth/Logout',
    }).then(() => {
      const cachedIframe = $('.cached_skin');
      if (cachedIframe && cachedIframe.length) {
        cachedIframe.remove();
      }
      dispatch({
        type: LOGOUT,
      });
    });
}

function receiveAuthedUser(authedUser, functions, routes, topNavigatorDatas, leftNavigatorDatas) {
  return {
    type: RECEIVE_AUTHED_USER,
    authedUser,
    functions,
    routes,
    topNavigatorDatas,
    leftNavigatorDatas,
  };
}

export function initAppDataFromAuthedInfo(authedInfo) {
  return (dispatch) => {
    const functions = initUserFunctionByAuthority(authedInfo);
    const routes = initRoute(functions);
    const topNavigatorDatas = initTopNavigator(functions, authedInfo);
    const leftNavigatorDatas = initLeftNavigator(functions, authedInfo);
    dispatch(
      receiveAuthedUser(authedInfo, functions, routes, topNavigatorDatas, leftNavigatorDatas),
    );
    // #7287 START
    if (authedInfo.institutionId) {
      const params = {
        s3FilePath: ADMIN_SCRIPT_S3_PATH.replace(':institutionId', authedInfo.institutionId),
        scriptClassName: S3_SCRIPT_CLASS_NAME.ADMIN_SCRIPT,
      };
      dispatch(getS3SignedUrl(params));
    }
    // #7287 END

    // sprint_20230418 #15 START
    if (authedInfo) {
      const { displayUserType, superuserType } = authedInfo.userInfo;
      // Step 12.0.0 START
      superuserType !== SUPERUSER_LOGIN_TYPE.INTEGRATION_ROOT_SUPERUSER &&
        postCheckAvailability(displayUserType)
          .then(({ redirectUri }) => {
            if (redirectUri) {
              window.location.href = redirectUri;
            }
          })
          .catch(({ message }) => {
            dispatch({ type: HIDE_MESSAGE });
            console.info(message[0]);
          });
      // Step 12.0.0 END
    }
    // sprint_20230418 #15 END
  };
}

function getServiceInfo(dispatch, param, camelizeJson) {
  return dispatch(getServiceInfoAfterLogin(param))
    .then((resdata) => {
      if (resdata && camelizeJson && camelizeJson.managementFunctionAuthorityInfo) {
        const {
          contentManagementAuthority,
          liveManagementAuthority,
        } = camelizeJson.managementFunctionAuthorityInfo;
        if (resdata.serviceList && resdata.serviceList.length) {
          const {
            usageSettingInfo,
            contractEnterpriseCd,
            contractEnterpriseBillingSystemRegisterFlag,
            contractEnterpriseStartDate,
            enterpriseCd,
            dormantUserDataAcquisitionPermissionFlag,
            serviceStartDate,
            contractEnterpriseHiddenStatus,
            mfaUsageFlag, // Step10.0.0
          } = resdata.serviceList[0];
          const content = contentManagementAuthority || 0;
          const live = liveManagementAuthority || 0;
          if (Object.keys(usageSettingInfo).length) {
            for (const key in usageSettingInfo) {
              let authority = content && usageSettingInfo[key] ? content : 0;
              camelizeJson.managementFunctionAuthorityInfo[key] = authority;
            }
            // Step 7.0 #3 START
            camelizeJson.usageSettingSufCustomize = usageSettingInfo.usageSettingSufCustomize;
            // Step 7.0 #3 END
            camelizeJson.usageSettingLive = USAGE_SETTING.UN_USE; //STEP12.1.0 TAS-16386
            camelizeJson.usageSettingVideo = usageSettingInfo.usageSettingVideo;
          }
          // sprint_20230418_#17 START
          const currentDate = moment().format(DEFAULT_DATE_FORMAT_SEARCH);
          camelizeJson.isShowContractRegion = enterpriseCd === contractEnterpriseCd && (contractEnterpriseStartDate > currentDate)
            && contractEnterpriseBillingSystemRegisterFlag === BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
          // sprint_20230418_#17 END
          // sprint_20230508_#19 START
          camelizeJson.isTrialExpire =
            contractEnterpriseStartDate <= currentDate &&
            contractEnterpriseBillingSystemRegisterFlag === BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
          // sprint_20230508_#19 END
          camelizeJson.dormantUserDataAcquisitionPermissionFlag = dormantUserDataAcquisitionPermissionFlag;
          // sprint_20230522_tma START
          camelizeJson.contractEnterpriseBillingSystemRegisterFlag = contractEnterpriseBillingSystemRegisterFlag;
          // sprint_20230522_tma END
          // sprint_20230605_tma START
          if (serviceStartDate) {
            const startDate = moment(serviceStartDate).startOf("day");
            const current = moment().startOf("day");
            var remainTrialDays = startDate.diff(current, "days");
            if (remainTrialDays < 0) {
              remainTrialDays = 0;
            }
            camelizeJson.remainTrialDays = remainTrialDays;
          }
          // sprint_20230605_tma END
          camelizeJson.contractEnterpriseHiddenStatus = contractEnterpriseHiddenStatus;
          camelizeJson.isOEMUser = isOEMUser(contractEnterpriseHiddenStatus); //Step 9.0.0
          camelizeJson.mfaUsageFlag = mfaUsageFlag; //Step 10.0.0
        }
      }
      dispatch(initAppDataFromAuthedInfo(camelizeJson));
    })
    .catch(() => {
      dispatch(initAppDataFromAuthedInfo(camelizeJson));
    });
}

// #7287 START
export function importS3SignedUrl(s3SignedUrl) {
  return (dispatch) => {
    dispatch({
      type: IMPORT_S3_SIGNED_URL,
      s3SignedUrl,
    });
  };
}

export function getS3SignedUrl(params) {
  const scriptClassName = params.scriptClassName;
  delete params.scriptClassName;
  return dispatch =>
    commonCallApi({
      path: 's3/GetS3SignedURL',
      data: params,
    }).then(({ s3SignedUrl }) => {
      const script = document.createElement('script');
      script.src = s3SignedUrl;
      script.type = 'text/javascript';
      script.className = scriptClassName;
      script.defer = true;
      document.body.appendChild(script);
      dispatch(importS3SignedUrl(s3SignedUrl));
    })
    .catch(({ message }) => {
      dispatch({ type: HIDE_MESSAGE });
      console.info(message[0]);
    });
}
// #7287 END

// #7303 START
export function checkCertificateUsage(loginInfo) {
  const { serviceCd } = loginInfo;
  const certificateData = {
    serviceCd,
    requestPasscd: EXTERNAL_REQUEST_PASSCD,
  };

  return (dispatch) => {
    commonCallApi({
      path: 'auth/CertificateUsageCheck',
      data: certificateData,
    })
      .then((camelizeJson) => {
        const { certificateUsageFlag, certificateLoginApiGatewayUrl } = camelizeJson;
        if (certificateUsageFlag) {
          const isIE = /*@cc_on!@*/false || !!document.documentMode;
          if (isIE) {
            const headers = {
              "X-SSapi-version": X_SSAPI_VERSION,
            };
            $.ajax({
              type: 'OPTIONS',
              url: `${certificateLoginApiGatewayUrl}/fgwv2/auth/Login`,
              headers,
              crossDomain: true,
              xhrFields: {
                withCredentials: true,
              },
              cache: false,
              async: false,
              statusCode: {
                200: function (responseObject, textStatus, jqXHR) {
                  dispatch(login(loginInfo, certificateLoginApiGatewayUrl));
                }
              },
            }).fail(function (jqXHR, textStatus) {
              dispatch({ type: HIDE_MESSAGE });
              return dispatch({
                type: SHOW_MESSAGE,
                message: MSG_USING_WRONG_CERTIFICATE,
                messageType: MESSAGE_TYPE.error,
              });
            })
          } else {
            dispatch(login(loginInfo, certificateLoginApiGatewayUrl));
          }
        } else {
          return dispatch(login(loginInfo));
        }
      });
  };
}
// #7303 END
// sprint_20230418_#17 START
export function getEnterpriseInfo(dispatch, param, camelizeJson) {
  return dispatch(getStructure(param))
    .then(() => {
      const { enterpriseCd } = camelizeJson;
      const { bySecernId, recordNum } = store.getState().enterprise.enterprises;
      if (bySecernId[enterpriseCd]) {
        // Step10.0.0 START
        const {
          enterpriseStartDate,
          billingSystemRegisterFlag,
          enterpriseLayer,
          contractEnterpriseHiddenStatus,
          usageSettingInfo,
        } = bySecernId[enterpriseCd];
        // Step10.0.0 END
        const currentDate = moment().format(DEFAULT_DATE_FORMAT_SEARCH);
        camelizeJson.isShowContractRegion =
          enterpriseLayer === ENTERPRISE_LAYER_L1 &&
          enterpriseStartDate > currentDate &&
          billingSystemRegisterFlag === BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
        // sprint_20230522_tma START
        camelizeJson.contractEnterpriseBillingSystemRegisterFlag = billingSystemRegisterFlag;
        camelizeJson.isShowMsgAfterTrialExpired =
          enterpriseStartDate <= currentDate &&
          billingSystemRegisterFlag === BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
        camelizeJson.isTrialExpire =
          enterpriseStartDate <= currentDate &&
          billingSystemRegisterFlag === BILLING_SYSTEM_REGISTER_FLAG_STATUS.NOT_REGISTERED;
        // sprint_20230522_tma END
        // sprint_20230605_tma START
        if (enterpriseStartDate) {
          const startDate = moment(enterpriseStartDate).startOf("day");
          const current = moment().startOf("day");
          var remainTrialDays = startDate.diff(current, "days");
          if (remainTrialDays < 0) {
            remainTrialDays = 0;
          }
          camelizeJson.remainTrialDays = remainTrialDays;
        }
        // sprint_20230605_tma END
        camelizeJson.contractEnterpriseHiddenStatus = contractEnterpriseHiddenStatus;
        camelizeJson.isEnterpriseLayerL1 = enterpriseLayer === ENTERPRISE_LAYER_L1;
        camelizeJson.isOEMUser = isOEMUser(contractEnterpriseHiddenStatus); //Step 9.0.0
        camelizeJson.usageSettingLive = USAGE_SETTING.UN_USE; // Step 10.0.0 //STEP12.1.0 TAS-16386
        camelizeJson.hasSubEnterprise = recordNum > 1; // Step 11.0.0
        camelizeJson.contractEnterpriseHiddenStatusInEnterprise = contractEnterpriseHiddenStatus; // step 12.0.0
      }
    });
}
// sprint_20230418_#17 END

// sprint_20230619_tma START
export function mailPassResetExecution(param) {
  return async (dispatch) => {
    try {
      await commonCallApi({
        path: 'auth/mail-pass-reset/execution',
        data: param,
      });
      return null;
    } catch (error) {
      return error;
    }
  };
}
// sprint_20230619_tma END

// Step 10.2.0 START
export function getSuperuserServiceRoleSettingList(superuserServiceRoleSettingListParam) {
  const param = {
    ...superuserServiceRoleSettingListParam,
  };
  return (dispatch) => commonCallApi({
    path: 'superuserServiceRole/SettingList',
    data: param,
    enterpriseId: 1,
  });
}
// Step 10.2.0 END

// Step 12.0.0 TAS-20042 START
export function getAllGroupOwnerFlag(camelizeJson) {
  const searchParam = {
    authCd: camelizeJson.authCd,
    token: camelizeJson.token,
    superuser_secern_id: camelizeJson?.userInfo?.userSecernId,
    return_max_record_num: 5000,
    start_position: 0,
  };
  return postUserGetManagementServiceList(searchParam).then((result) => {
    const allGroupOwnerFlag = result.serviceList?.find(
      (item) => item.institutionId === camelizeJson?.institutionId
    )?.allGroupOwnerFlag ?? false;
    camelizeJson.allGroupOwnerFlag = allGroupOwnerFlag;
  });
}
// Step 12.0.0 TAS-20042 END
